module.exports = __webpack_public_path__ + "media/sub3-5-2.7c439cad.mp4";